<div *ngIf="dashboardView!='charts'" class="p-grid p-mt-0">
    <div *ngIf="!dashboardView" class="p-col-12 p-px-3">
        <div class="card p-grid p-mb-2">
            <div class="p-col-12 p-p-0">
                <p-menubar [model]="menuItems" styleClass="top-menu submenu-align-right p-p-0">
                    <ng-template pTemplate="start" style="width: 100%;">
                        <span style="width: fit-content;display: inline-flex;">
                            <p-dropdown [options]="filterDataByTime" [(ngModel)]="selectedDateFilter"
                                (onChange)="changeRange(true)" optionLabel="label" appendTo="body" placeholder="Select Date">
                            </p-dropdown>
                            <p-button *ngIf="selectedDateFilter?.code == 'custom'" (click)="customDateRange=true" class="custom-date-selection" icon="pi pi-calendar" />
                            <!-- <p-calendar styleClass="custom-date-selection" class="p-ml-2" appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                                dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="dateFrom" [maxDate]="dateTo"
                                [disabled]="selectedDateFilter?.code !== 'custom'"
                                (onSelect)="changeRange(true)">
                            </p-calendar>
                            <p-calendar styleClass="custom-date-selection" class="p-ml-2" appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                                dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="dateTo" [minDate]="dateFrom"
                                [disabled]="selectedDateFilter?.code !== 'custom'"
                                (onSelect)="changeRange(true)">
                            </p-calendar> -->
                        </span>
                        <span *ngIf="!hideChannelFilter" style="width: fit-content;" class="p-ml-2">
                            <p-dropdown [options]="accountsChannelList"
                                [(ngModel)]="selectedChannel"
                                (onChange)="onChangeChannel()"
                                optionLabel="name"
                                appendTo="body"
                                placeholder="Select Channel">
                            </p-dropdown>
                        </span>
                        <span *ngIf="[reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, reportsVisitsNames.getterritorywiseleadvisithistoryofrep].includes(selectedWindow)" style="width: fit-content;" class="p-ml-2">
                            <p-treeSelect [options]="territoryNamesList" [(ngModel)]="selectedTerritory"
                                [selectionMode]="'multiple'"
                                [metaKeySelection]="false"
                                (onNodeSelect)="changeTerritory($event)" (onNodeUnselect)="changeTerritory($event)"
                                (onClear)="changeTerritory($event)"
                                appendTo="body"
                                placeholder="Filter by Territory" [filter]="true" [showClear]="true"
                                [filterInputAutoFocus]="true" class="custom-treeselect terriory-filter">
                            </p-treeSelect>
                        </span>
                        <span class="p-input-icon-left" style="float: right; margin-left: 5px;">
                            <i class="pi pi-search searchPosition"></i>
                            <input type="text" style="float: right; margin: 2px 5px 0px 0px;" pInputText
                                placeholder="Search..." [formControl]="searchControl" />
                        </span>
                        <span class="p-mr-2 group-by-wrapper">
                            <button icon="pi pi-tags" pButton pRipple type="button"
                                class="p-button-secondary p-button-text"
                                (click)="groupby.toggle($event);showGroupBy()" pTooltip="Group by"
                                tooltipPosition="top">
                            </button>
                            <span *ngIf="selectedGroupByValue" class="group-by-badge"></span>
                        </span>
                        <app-filters [listCols]="filterCols"
                            [selectedParentModule]="{ name: selectedModuleName, objectId: selectedModuleId, channelId: selectedChannel?.id}"
                            [saveFilterData]="saveFilterData"
                            (applyFiltersColumns)="applyFilters($event)">
                        </app-filters>
                    </ng-template>
                </p-menubar>
            </div>
        </div>
    </div>

    <p-overlayPanel #groupby [showCloseIcon]="true" [style]="{width: '300px'}">
        <ng-template pTemplate>
            <label>Group By</label>
            <p-dropdown [options]="enabledListCols" class="panelDD" [filter]="true"
                [(ngModel)]="selectedGroupBy" optionLabel="name" placeholder="Select Field">
            </p-dropdown>
            <div class="p-text-right p-mt-2">
                <p-button label="Reset" class="p-button-secondary p-mt-2 p-mr-2"
                    (click)="resetGroup(true);groupby.hide()" [disabled]="!selectedGroupBy"></p-button>
                <p-button label="Apply" class="p-mt-2" (onClick)="applyGroup();groupby.hide()"
                    [disabled]="!selectedGroupBy"></p-button>
            </div>
        </ng-template>
    </p-overlayPanel>

    <div class="p-col-12">
        <div class="card">

            <div *ngIf="!dashboardView" class="p-grid">
                <div class="p-col-12">
                    <div class="p-d-flex p-jc-between">
                        <h5 class="p-ml-3">{{reportName}}</h5>
                        <p *ngIf="dateFrom && dateTo" class="p-mr-3"><strong>{{dateFrom | date: 'MM/dd/yyyy'}}</strong> to <strong>{{dateTo | date: 'MM/dd/yyyy'}}</strong></p>
                    </div>
                </div>
            </div>

            <div class="p-grid" *ngIf="!hideChart && !dashboardView">
                <div class="p-col-12">
                    <p-card>
                        <div class="p-d-flex" style="height: 300px">
                            <ng-container *ngTemplateOutlet="chartTemplate"></ng-container>
                        </div>
                    </p-card>
                </div>
            </div>

            <!-- <app-template7
                [stackedBar]="stackedBarByRep"
                [reportName]="reportName"
                [dateFrom]="dateFrom"
                [dateTo]="dateTo"
                [hideChart]="hideChart"
                [showChartFilters]="true"
                [selectedChartType]="selectedChartType"
                [chartFilters]="chartFilters"
                (changeChartFilter)="changeChartFilter($event)">
            </app-template7> -->

            <div class="main-content">
                <p-table #visitReportsTable appFloatThead [forceReflow]="reflowTable" [showFloatHeader]="showFloatHeader"
                    [value]="reportResults"
                    [columns]="savedListCols"
                    [lazy]="true"
                    (onLazyLoad)="getAllAccountsWithPagination($event)"
                    (onRowSelect)="onRowSelect()"
                    (onRowUnselect)="selectedReportData=null"
                    [totalRecords]="totalRecords"
                    [rows]="pageSize" [scrollable]="true"
                    [style]="{width:'100%'}" [paginator]="true" selectionMode="single"
                    [rowsPerPageOptions]="tableShowMore" [(selection)]="selectedReportData" dataKey="id"
                    [(first)]="first"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    styleClass="p-datatable-gridlines floatthead leadTable" [resizableColumns]="true"
                    [floatTableRef]="visitReportsTable" floatTableClassRef="floatthead">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngIf="selectedGroupByValue && selectedView != 'split'"
                                style="border-right: 1px solid var(--primary-color);"
                                pResizableColumn
                                [ngClass]="{'filtered-column': filteredColumns.includes(selectedGroupByValue.name)}">
                                <div class="p-d-flex p-ai-center">
                                    <button type="button" pButton pRipple
                                        class="p-button-text p-button-rounded p-button-plain group-expand-button"
                                        (click)="onAllGroupExpand()" [pTooltip]="groupAllExpanded ? 'Collapse All': 'Expand All'"
                                        [icon]="groupAllExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                    </button> Group: {{selectedGroupByValue.name}}
                                </div>
                            </th>
                            <ng-container *ngFor="let col of columns;">
                                <th *ngIf="col.enabled && (selectedGroupByValue?.columnName!=col.columnName)" [pSortableColumn]="col.columnName" [pSortableColumnDisabled]="['tags'].includes(col.columnName)"
                                [ngClass]="{'filtered-column': filteredColumns.includes(col.columnName)}"
                                style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                                    {{col.name}}
                                    <p-sortIcon *ngIf="!['tags'].includes(col.columnName)" [field]="col.columnName" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr class="parentRow" *ngIf="selectedGroupByValue">
                            <td colspan="30" class="group-expand-row">
                                <div class="p-d-flex p-ai-center">
                                    <button type="button" pButton pRipple
                                        class="p-button-text p-button-rounded p-button-plain group-expand-button"
                                        (click)="onGroupExpand(rowData)"
                                        [icon]="rowData?.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                    </button>
                                    <span [pTooltip]="rowData.groupByValue">
                                        <ng-container [ngSwitch]="selectedGroupByValue?.fieldDataType">
                                            <ng-container *ngSwitchCase="'DateTime'">
                                                <ng-container *ngIf="selectedGroupByValue?.isCustom && selectedGroupByValue?.isDateWithTime">
                                                    {{ selectedGroupByValue.name }} - {{ rowData.groupByValue ? (rowData.groupByValue | localDate:'dateTime':false) : 'NA' }} ({{rowData.totalNumberOfRows}})
                                                </ng-container>
                                                <ng-container *ngIf="!(selectedGroupByValue?.isCustom && selectedGroupByValue?.isDateWithTime)">
                                                    {{ selectedGroupByValue.name }} - {{ rowData.groupByValue ? (rowData.groupByValue | date:'MM/dd/yyyy') : 'NA' }} ({{rowData.totalNumberOfRows}})
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'Time'">
                                                {{ selectedGroupByValue.name }} - {{ rowData.groupByValue ? (rowData.groupByValue | onlyTime) : 'NA' }} ({{rowData.totalNumberOfRows}})
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ selectedGroupByValue.name }} - {{ rowData.groupByValue ? (rowData.groupByValue | shorten:27) : 'NA' }} ({{rowData.totalNumberOfRows}})
                                            </ng-container>
                                        </ng-container>
                                    </span>
                                </div>
                            </td>
                        </tr>
                        <ng-container *ngIf="selectedGroupByValue && rowData?.expanded && rowData?.list?.length>0">
                            <tr *ngFor="let listRowData of rowData.list" [pSelectableRow]="listRowData" [pContextMenuRow]="listRowData">
                                <td style="text-align: left;" *ngIf="selectedGroupByValue && selectedView != 'split'"></td>
                                <ng-container *ngFor="let col of columns">
                                    <td *ngIf="col.enabled && (selectedGroupByValue?.columnName!=col.columnName)" style="text-align: left;"
                                    [class.action-tag] = "col.columnName =='tags'">
                                        <ng-container *ngIf="!col?.depth; else depthTemplate">
                                            <ng-container *ngIf="col.columnName =='tags'">
                                                <ng-container *ngFor="let s of listRowData?.tags; let i = index">
                                                    <p-tag styleClass="p-ml-1" [value]="s?.name" [style]="{'background-color': s.color}"></p-tag>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngIf="(['twitter','website', 'facebook','linkedin','instagram',
                                                                    'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                                                    'contactsociallinkedin','contactsocialinstagram'].indexOf(col.columnName) >= 0
                                                                    || ['URL'].includes(col?.formControlType)
                                                                );
                                                                else elseData">
                                                <a href="{{listRowData[col.columnName] | url}}" target="_blank">{{
                                                    listRowData[col.columnName] | shorten }}</a>
                                            </ng-container>
                                            <ng-container *ngIf="phoneFields.includes(col.columnName)">
                                                {{ listRowData[col.columnName] | phoneNumber: listRowData[col.columnName+'code'] }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='Percentage'">
                                                {{ listRowData[col.columnName] | percentageSymbol }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='Currency'">
                                                {{ listRowData[col.columnName] | currencySymbol }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='RichText'">
                                                {{ listRowData[col.columnName] | removeHtmlTags | shorten }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='EncryptedText'">
                                                {{ listRowData[col.columnName] ? '******' : ''}}
                                            </ng-container>
                                            <ng-template #elseData>
                                                <ng-container *ngIf="!['Percentage','Currency','RichText','EncryptedText'].includes(col?.formControlType) && col.columnName != 'tags' && !phoneFields.includes(col.columnName)">
                                                    <ng-container [ngSwitch]="col?.fieldDataType">
                                                        <ng-container *ngSwitchCase="'DateTime'">
                                                        {{ col?.isDateWithTime ? (col?.isCustom ? (listRowData[col.columnName] | localDate:'dateTime':false) : (listRowData[col.columnName] | localDate:'date')) : (listRowData[col.columnName] | date:'MM/dd/yyyy') }}
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'Time'">
                                                        {{ listRowData[col.columnName] | onlyTime }}
                                                        </ng-container>
                                                        <ng-container *ngSwitchDefault>
                                                            <ng-container *ngIf="['visit_timespent','visit_t_timespent'].includes(col?.columnName)">
                                                                {{listRowData[col.columnName] | timeConvert }}
                                                            </ng-container>
                                                            <ng-container *ngIf="!['visit_timespent','visit_t_timespent'].includes(col?.columnName)">
                                                                {{listRowData[col.columnName] | shorten:50 }}
                                                            </ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #depthTemplate>
                                            {{ listRowData | columnName:col?.depth }}
                                        </ng-template>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="!selectedGroupByValue">
                            <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                                <ng-container *ngFor="let col of columns">

                                    <td *ngIf="col.enabled" style="text-align: left;">
                                        <ng-container *ngIf="!col?.depth; else depthTemplate">
                                            <ng-container *ngIf="col.columnName =='tags'">
                                                <ng-container *ngFor="let s of rowData?.tags; let i = index">
                                                    <p-tag styleClass="p-ml-2" [value]="s?.name" [style]="{'background-color': s.color}"></p-tag>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngIf="(['twitter','website','other','facebook','linkedin','instagram',
                                                                'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                                                'contactsociallinkedin','contactsocialinstagram']
                                                                .indexOf(col.columnName) >= 0
                                                                || ['URL'].includes(col?.formControlType));
                                                                else elseData">
                                                <a href="{{rowData[col.columnName] | url}}" target="_blank">{{rowData[col.columnName] | shorten }}</a>
                                            </ng-container>
                                            <ng-container *ngIf="phoneFields.includes(col.columnName)">
                                                {{ rowData[col.columnName] | phoneNumber: rowData[col.columnName+'code'] }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='Percentage'">
                                                {{ rowData[col.columnName] | percentageSymbol }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='Currency'">
                                                {{ rowData[col.columnName] | currencySymbol }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='RichText'">
                                                {{ rowData[col.columnName] | removeHtmlTags | shorten }}
                                            </ng-container>
                                            <ng-container *ngIf="col?.formControlType=='EncryptedText'">
                                                {{ rowData[col.columnName] ? '******' : ''}}
                                            </ng-container>
                                            <ng-template #elseData>
                                                <ng-container *ngIf="!['Percentage','Currency','RichText','EncryptedText'].includes(col?.formControlType) && col.columnName != 'tags' && !phoneFields.includes(col.columnName)">
                                                    <ng-container [ngSwitch]="col?.fieldDataType">
                                                        <ng-container *ngSwitchCase="'DateTime'">
                                                        {{ col?.isDateWithTime ? (col?.isCustom ? (rowData[col.columnName] | localDate:'dateTime':false) : (rowData[col.columnName] | localDate:'date')) : (rowData[col.columnName] | date:'MM/dd/yyyy') }}
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'Time'">
                                                        {{ rowData[col.columnName] | onlyTime }}
                                                        </ng-container>
                                                        <ng-container *ngSwitchDefault>
                                                            <ng-container *ngIf="['visit_timespent','visit_t_timespent'].includes(col?.columnName)">
                                                                {{rowData[col.columnName] | timeConvert }}
                                                            </ng-container>
                                                            <ng-container *ngIf="!['visit_timespent','visit_t_timespent'].includes(col?.columnName)">
                                                                {{rowData[col.columnName] | shorten:50 }}
                                                            </ng-container>
                                                        </ng-container>
                                                    </ng-container>

                                                    <span *ngIf="col.columnName === 'currentStage' && rowData.isConvertedToAccount && rowData.leadStageId==qualifiedId" class="p-ml-2">*</span>

                                                </ng-container>
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #depthTemplate>
                                            {{rowData | columnName:col?.depth }}
                                        </ng-template>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        <tr *ngIf="selectedGroupByValue && rowData?.expanded" style="margin-bottom: 5px;">
                            <td colspan="30" style="padding: 0px!important;">
                                <p-paginator styleClass="child-paginator" (onPageChange)="onListPageChange($event,rowData)" [showCurrentPageReport]="true"
                                    [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'" [first]="(rowData.pageNumber-1)"
                                    [rows]="rowData.pageSize" [totalRecords]="rowData.totalNumberOfRows">
                                </p-paginator>
                            </td>
                        </tr>
                        <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" #depth>
                            <ng-template [ngTemplateOutlet]="Recursion"
                                [ngTemplateOutletContext]="{$implicit: rowData, columns:columns}"></ng-template>
                        </ng-template>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="30">
                                <div class="p-text-center">{{noDataFoundOrLoadingText}}</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>

<div *ngIf="dashboardView=='charts'" class="dashboard-charts p-d-flex">
    <ng-container *ngTemplateOutlet="chartTemplate"></ng-container>
</div>

<ng-template #chartTemplate>
    <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">Visit Counts</p>
    <div style="flex-grow:1; width:100%">
        <canvas
            baseChart
            [data]="barChartData"
            [options]="barChartOptions"
            [type]="'bar'">
        </canvas>
    </div>
</ng-template>

<p-dialog header="Visit Details" [(visible)]="displayVisitDetails" [modal]="true" [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="visitDetailsData" [totalRecords]="visitTotalRecords"
                [columns]="visitDetailsCols" [rows]="15" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [paginator]="true"
                [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
                    <ng-template pTemplate="caption">
                        <div *ngIf="[reportsVisitsNames.avareagefieldvisitbyrep].includes(selectedWindow)" class="p-d-flex p-ai-center p-jc-between">
                            <h5 class="p-mb-0">Field Visited by {{selectedReportData?.visit_username}}</h5>
                            <div class="p-d-flex p-ai-center p-text-right">
                                <p class="p-mb-0 p-mr-2">{{dateFrom | date: 'MM/dd/yyyy'}} - {{dateTo | date: 'MM/dd/yyyy'}}</p>
                                <div>
                                    <p-button (click)="openAsPDF('',selectedReportData?.visit_username)" class="p-mr-2" icon="pi pi-print"></p-button>
                                    <p-button (click)="downloadAsXLS(selectedReportData?.visit_username)" class="p-mr-2" icon="pi pi-download"></p-button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="[reportsVisitsNames.getaccountfieldvisithistorybyrep,reportsVisitsNames.getleadfieldvisithistorybyrep].includes(selectedWindow)" class="p-d-flex p-ai-center p-jc-between">
                            <h5 class="p-mb-0">{{selectedReportData?.visit_businessname}} Visited by {{selectedReportData?.visit_username}}</h5>
                            <div class="p-d-flex p-ai-center p-text-right">
                                <p class="p-mb-0 p-mr-2">{{dateFrom | date: 'MM/dd/yyyy'}} - {{dateTo | date: 'MM/dd/yyyy'}}</p>
                                <div>
                                    <p-button (click)="openAsPDF(selectedReportData?.visit_businessname,selectedReportData?.visit_username)" class="p-mr-2" icon="pi pi-print"></p-button>
                                    <p-button (click)="downloadAsXLS(selectedReportData?.visit_username)" class="p-mr-2" icon="pi pi-download"></p-button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="[reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, reportsVisitsNames.getterritorywiseleadvisithistoryofrep, reportsVisitsNames.getterritorywiseaccountvisithistory, reportsVisitsNames.getterritorywiseleadvisithistory].includes(selectedWindow)"
                            class="p-d-flex align-items-center p-jc-between">
                            <h5 class="p-mb-0">{{selectedReportData?.visit_businessname}} Visited by Rep</h5>
                            <div class="p-d-flex p-ai-center p-text-right">
                                <p class="p-mb-0  p-mr-2">{{dateFrom | date: 'MM/dd/yyyy'}} - {{dateTo | date: 'MM/dd/yyyy'}}</p>
                                <div>
                                    <p-button (click)="openAsPDF('','')" class="p-mr-2" icon="pi pi-print"></p-button>
                                    <p-button (click)="downloadAsXLS()" class="p-mr-2" icon="pi pi-download"></p-button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <ng-container *ngFor="let col of columns">
                                <th *ngIf="col.enabled" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                                    <span>{{col.name}}</span>
                                </th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr class="{{rowData?.rowColor}}">
                            <td *ngFor="let col of columns">
                                <ng-container [ngSwitch]="col?.fieldDataType">
                                    <ng-container *ngSwitchCase="'datetime'">
                                        {{ rowData[col.columnName] | localDate }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'time'">
                                        {{ rowData[col.columnName] | localDate:'h:mm a' }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'date'">
                                        {{ rowData[col.columnName] | localDate:'MM/DD/YYYY' }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'timespan'">
                                        {{ (rowData[col.columnName] || rowData[col.columnName]==0) ? (rowData[col.columnName] | timeConvert) : '' }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'number2dp'">
                                        {{ rowData[col.columnName] | customNumberFormat: fractionDigits }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'currencySymbol'">
                                        {{ rowData[col.columnName] | customNumberFormat: fractionDigits | currencySymbol }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'percentageSymbol'">
                                        {{ rowData[col.columnName] | numberWithPercentageSymbol: fractionDigits }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'string'">
                                        <span [pTooltip]="rowData[col.columnName]" tooltipPosition="top">
                                            {{ rowData[col.columnName] | shorten:50 }}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        {{ rowData[col.columnName] }}
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayVisitDetails=false;" label="Cancel" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Custom Date Range" [(visible)]="customDateRange" [modal]="true" [style]="{width: '350px'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label class="p-m-2"><strong>From Date</strong></label>
                <p-calendar styleClass="custom-date-selection" class="p-ml-2" appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateFrom" [maxDate]="dateTo"
                    [disabled]="selectedDateFilter?.code !== 'custom'">
                </p-calendar>
            </div>
            <div class="p-col-12">
                <label class="p-m-2"><strong>To Date</strong></label>
                <p-calendar styleClass="custom-date-selection" class="p-ml-2" appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateTo" [minDate]="dateFrom"
                    [disabled]="selectedDateFilter?.code !== 'custom'">
                </p-calendar>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="customDateRange=false;" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="applyCustomDateRange(true)" label="Apply" class="p-button-primary"></button>
    </ng-template>
</p-dialog>

<p-dialog [header]="filterPopupHeader" (onHide)="cancelFilterPopup()" [(visible)]="displayFilterPopup" [modal]="true"
    [style]="{width: '400px'}" appendTo="body">
    <ng-template pTemplate="content">
        <div class="p-grid" style="flex-grow: 1;">
            <div class="p-col-12">
                <h6 class="p-mb-1">Select Date</h6>
                <p-dropdown [options]="filterDataByTime" id="rangeItems" [style]="{'width':'100%'}"
                    (onChange)="changeRange(false)" [(ngModel)]="selectedDateFilter" optionLabel="label" appendTo="body"
                    placeholder="Select Time">
                </p-dropdown>
            </div>
            <div class="p-col-6">
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateFrom"
                    [disabled]="selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}">
                </p-calendar>
            </div>
            <div class="p-col-6">
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateTo"
                    [disabled]="selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}">
                </p-calendar>
            </div>
            <div *ngIf="!hideChannelFilter" class="p-col-12">
                <h6 class="p-mb-1">Select Channel</h6>
                <p-dropdown [options]="accountsChannelList" id="channelList" [style]="{'width':'100%'}"
                    [(ngModel)]="selectedChannel" (onChange)="onChangeChannel(true)" optionLabel="name" appendTo="body" placeholder="Select Channel">
                </p-dropdown>
            </div>
            <div *ngIf="[reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, reportsVisitsNames.getterritorywiseleadvisithistoryofrep].includes(selectedWindow)" class="p-col-12">
                <h6 class="p-mb-1">Select Territory Name </h6>
                <p-treeSelect [options]="territoryNamesList" [(ngModel)]="selectedTerritory"
                    [selectionMode]="'multiple'"
                    [metaKeySelection]="false"
                    appendTo="body"
                    placeholder="Filter by Territory" [filter]="true" [showClear]="true"
                    [filterInputAutoFocus]="true" class="custom-treeselect terriory-filter">
                </p-treeSelect>
            </div>
        </div>
    </ng-template>
    <p-footer>
        <button type="button" pButton label="Cancel" (click)="cancelFilterPopup()" class="p-button-secondary"></button>
        <button type="submit" pButton label="Apply"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applyOnly)"></button>
        <button type="submit" pButton label="Apply & Save"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applySave)"></button>
    </p-footer>
</p-dialog>

<app-column-settings-modal-for-rules [displayColumnSettings]="displayColumnSettings"
    [moduleName]="selectedModuleName" [settingsObj]="columnSettingsN" [disabledLabelNames]="disabledLabelColumns"
    [selectedView]="'list'" [maxColumn]="30" [channelId]="selectedChannel?.id"
    (savedColumnSettings)="savedColumnSettings($event)" (cancelColumnSettings)="cancelColumnSettings()">
</app-column-settings-modal-for-rules>
